import React from "react";
import { cn } from "../../../lib/utils";

/**
 * A feed of cards, each with a coloured dot, a bold title, a " · "-joined detail, an
 * optional badge and a right-aligned date (wireframe: "● Session completed · Yoga
 * therapy · pack 6 of 10 · note added ........ Today").
 *
 * Presentational: `items` are `[{id, dotClass, title, detail, body, badge, when, testId}]`,
 * already translated. `body` is text someone else wrote (a form visitor's message),
 * shown whole under the line, line breaks kept, never joined into the " · " detail.
 */
export default function TimelineFeed({ items, testId }) {
  return (
    <ol data-testid={testId} className="space-y-2">
      {items.map((item) => (
        <li key={item.id} data-testid={item.testId} className="flex gap-3 rounded-xl border border-eh-border-soft bg-eh-cream px-4 py-3">
          <span aria-hidden="true" className={cn("mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full", item.dotClass)} />
          <div className="min-w-0 flex-1 text-sm text-eh-ink">
            <span className="font-semibold">{item.title}</span>
            {item.detail && <span> · {item.detail}</span>}
            {item.body && (
              <blockquote data-testid={item.testId && `${item.testId}-body`}
                className="mt-2 whitespace-pre-wrap break-words border-l-2 border-eh-border pl-3 text-eh-ink">
                {item.body}
              </blockquote>
            )}
            {item.badge && <div className="mt-1">{item.badge}</div>}
          </div>
          <time dateTime={item.at} className="shrink-0 text-sm text-eh-muted">{item.when}</time>
        </li>
      ))}
    </ol>
  );
}
